import request from "./request";
import { getCookie } from "@szgc/plt-core-v2";
const prefix = getCookie("plt-api-route") || "";

/**
 * 获取数据源字段树形列表
 * @param dataConfigId
 */
export function getDataPropList(dataConfigId: string) {
  return request({
    url: `${prefix}/api/appproc/data-schemas/${dataConfigId}/properties`,
    method: "get"
  });
}
/**
 * 查询表单数据
 * @param dataConfigId
 */
export async function getFormData(dataConfigId: string, data?: any) {
  return request({
    url: `${prefix}/api/appproc/main-data/read/${dataConfigId}/data/read`,
    method: "post",
    data
  });
}
/**
 * 查询字典类型列表
 * @param
 */
export function getDictTypeList() {
  return request({
    url: `${prefix}/api/system/dicts/types`,
    method: "get"
  });
}
/**
 * 上传附件多选
 * @param
 */
export function uploadMultiAttachment(pacId: string, businessId: string, data: any, params?: any) {
  return request({
    url: `${prefix}/api/appproc/packages/${pacId}/matters/${businessId}/attachments/multi-upload`,
    method: "post",
    timeout: 0,
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data,
    params
  });
}
/**
 * 上传附件单选
 * @param
 */
export function uploadSingleAttachment(pacId: string, businessId: string, data: any, params?: any) {
  return request({
    url: `${prefix}/api/appproc/packages/${pacId}/matters/${businessId}/attachments/single-upload`,
    method: "post",
    timeout: 0,
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data,
    params
  });
}
/**
 * 查询附件信息
 * @param
 */
export function getAttachmentInfo(data: any) {
  return request({
    url: `${prefix}/api/attachments/show-time`,
    method: "post",
    data
  });
}

/**
 * 回去字典数据
 * @param
 */
export function getDistLists(data: any) {
  return request({
    url: `${prefix}/api/appproc/prime/select`,
    method: "post",
    data
  });
}

/**
 * 签章图片列表
 * @param
 */
export function getSealList() {
  return request({
    url: `/authc-api/system/seals`,
    method: "get"
  });
}

/**
 * 查看表单明细
 * @param data
 * @returns
 */
export function getSelectObject(data: any) {
  return request<Record<string, any>[]>({
    url: `${prefix}/api/appproc/prime/selected-form`,
    method: "post",
    data
  });
}

/**
 * 获取用户自定义配置
 * @param
 */
export function getUserConfig(userId: string, bmName: string) {
  return request({
    url: `/authc-api/system/customized/users/${userId}/configs/${bmName}`,
    method: "get"
  });
}
/**
 * 更新用户自定义配置
 * @param
 */
export function updateUserConfig(userId: string, data: any) {
  return request({
    url: `/authc-api/system/customized/users/${userId}/configs`,
    method: "post",
    data
  });
}

/**
 * 获取系统配置
 * @returns
 */
export function getSyConfig() {
  return request({
    url: "/secure/current"
  });
}
/**
 * 契约锁-发起电子签约并获取电子签约文件id
 * @param businessId
 * @param parmas
 * @param data
 * @returns
 */
export function qiyuesuoCreateByCategory(businessId: string, data: Record<string, any>) {
  return request({
    url: `/api/appproc/${businessId}/qiyuesuo/create-by-category`,
    method: "post",
    data
  });
}
/**
 * 契约锁-发起电子签约并获取电子签约文件id
 * @param businessId
 * @param parmas
 * @param data
 * @returns
 */
export function qiyuesuoCreateByCategoryWithoutBussiness( data: Record<string, any>) {
  return request({
    url: `/api/appproc/qiyuesuo/create-by-category`,
    method: "post",
    data
  });
}

/**
 * 契约锁-添加签署方并生成电子签约签署页面
 * @param data
 * @returns
 */
export function qiyuesuoAddSignatory(data: Record<string, any>) {
  return request<string>({
    url: `/api/appproc/qiyuesuo/add-signatory`,
    method: "post",
    data
  });
}
/**
 * 契约锁-作废电子签约
 * @param contractId
 * @returns
 */
export function qiyuesuoContractCancel(contractId: string) {
  return request({
    url: `/api/appproc/qiyuesuo/${contractId}/contract-cancel`,
    method: "put"
  });
}
/**
 * 契约锁-查看电子签约文件浏览页面
 * @param contractId
 * @returns
 */
export function qiyuesuoContractViewPageUrl(contractId: string) {
  return request<string>({
    url: `/api/appproc/qiyuesuo/${contractId}/contract-view-pageurl`
  });
}
/**
 * 获取业务包的流程数据源与主数据源映射关系信息
 * @param pacId
 * @returns
 */
export function getRelProcPrimeDataProps(
  pacId: string,
  dataConfigId: string,
  childPropertyNamePath: string
) {
  return request<Record<string, string>[]>({
    url: `/api/appproc/read/package:${pacId}/${dataConfigId}/${childPropertyNamePath}/rel-proc-prime-data-props`,
    method: "get",
  });
}